import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: "search",
  initialState: {
    searchList: [],
    isFetching: false,
    error: false,
    success: false,
    totalPage: 0,
    totalItem: 0,
  },
  reducers: {
    search: (state) => {
      state.isFetching = true;
      state.error = false;
      state.success = false
    },
    searchSuccess: (state, action) => {
      state.isFetching = false;
      state.success = true;
      state.searchList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    searchFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const searchActions = searchSlice.actions;
export default searchSlice.reducer;
